<!-- components/HoldToContinueButton.vue -->
<template>
  <div class="relative flex cursor-pointer items-center justify-center select-none">
    <div
      class="relative h-24 w-24 rounded-full border-4 transition-all duration-500"
      :class="[
        completed ? 'border-border-positive bg-fill-positive scale-105' : 'border-white',
        isCharging && !completed ? 'animate-pulse' : '',
      ]"
      @mousedown="startCharge"
      @touchstart.prevent="startCharge"
      @mouseup="cancelCharge"
      @mouseleave="cancelCharge"
      @touchend="cancelCharge"
      @pointerup="cancelCharge"
      @pointerleave="cancelCharge"
      @pointercancel="cancelCharge"
    >
      <svg
        class="absolute top-0 left-0"
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        v-if="!completed"
      >
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="white"
          stroke-width="8"
          fill="none"
          :stroke-dasharray="dashArray"
          :stroke-dashoffset="dashOffset"
          stroke-linecap="round"
        />
      </svg>
      <div
        class="font-quicksand absolute bottom-0 flex h-full w-full items-center justify-center text-sm text-white"
      >
        <div class="text-center" v-if="!completed">Hold to continue</div>
        <div v-else>
          <check-circle class="h-12 w-12"></check-circle>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { CheckCircle } from 'lucide-vue-next';
import { computed, ref } from 'vue';

const emit = defineEmits(['charged']);

const isCharging = ref(false);
const progress = ref(0);
let interval: any = null;

const duration = 2000; // ms
const steps = 100;
const increment = duration / steps;

const dashArray = 2 * Math.PI * 45;
const dashOffset = computed(() => dashArray * (1 - progress.value));

const completed = ref(false);

async function startCharge() {
  if (isCharging.value || completed.value) return;
  await Haptics.impact({ style: ImpactStyle.Light });

  isCharging.value = true;
  progress.value = 0;

  interval = setInterval(async () => {
    progress.value += 1 / steps;
    if (progress.value >= 1) {
      await Haptics.notification({ type: NotificationType.Success });
      clearInterval(interval);
      completed.value = true;
    }
  }, increment);
}

function cancelCharge() {
  isCharging.value = false;
  clearInterval(interval);

  if (progress.value >= 1) {
    emit('charged');
  }
  progress.value = 0;
  completed.value = false;
}
</script>

<style scoped>
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
.animate-pulse {
  animation: pulse 1.5s infinite;
}
</style>
